import _ from 'lodash';

import { DEFAULT_EMPTY_VALUE } from '@/utils/constants';
import RoleName from '../enumerator/RoleName';

export const ROLE_NAME_TRANSLATION_PREFIX = 'roleName';

const LEGACY_ROLE_TO_ENUM_KEY = Object.freeze({
  RoleAdmin: 'Admin',
  RoleSuperAdmin: 'SuperAdmin',
  RoleSupport: 'Support',
  RoleUser: 'User',
  RoleCollaborator: 'Collaborator',
  RoleAuditor: 'Auditor',
  RoleUserManager: 'UserAdmin',
  RolePartner: 'Partner',
  RoleOwner: 'Owner',
  RoleBillingAdmin: 'BillingAdmin',
  RoleCommercialAdmin: 'CommercialAdmin',
});

const ROLE_NAME_MEMBERS = new Set(Object.values(RoleName));

export const normalizeRoleToMember = (value) => {
  if (value == null || value === '') return null;

  const raw = typeof value === 'object' && value?.value != null ? value.value : value;
  if (typeof raw !== 'string') return null;

  if (ROLE_NAME_MEMBERS.has(raw)) return raw;

  if (raw.startsWith('Role')) {
    const enumKey = LEGACY_ROLE_TO_ENUM_KEY[raw];
    return enumKey ? RoleName[enumKey] || null : null;
  }

  const enumKey = Object.keys(RoleName).find((key) => RoleName[key] === raw);
  return enumKey ? RoleName[enumKey] : null;
};

export const getRoleNameTranslationKey = (memberOrLegacy) => {
  const member = normalizeRoleToMember(memberOrLegacy);
  if (!member) return null;

  const enumKey = Object.keys(RoleName).find((key) => RoleName[key] === member);
  if (!enumKey) return `${ROLE_NAME_TRANSLATION_PREFIX}.${member}`;

  return `${ROLE_NAME_TRANSLATION_PREFIX}.${_.camelCase(enumKey)}`;
};

export const formatRoleName = (memberOrLegacy, formatMessage) => {
  const key = getRoleNameTranslationKey(memberOrLegacy);
  if (!key) return memberOrLegacy || DEFAULT_EMPTY_VALUE;
  if (!formatMessage) return key;
  return formatMessage({ id: key, defaultMessage: memberOrLegacy });
};

export const getRoleNameOptions = () =>
  Object.keys(RoleName)
    .map((key) => ({
      value: RoleName[key],
      label: `${ROLE_NAME_TRANSLATION_PREFIX}.${_.camelCase(key)}`,
      locale: true,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
